(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["announcement-bar"] && !Shopify.designMode) return;
  try {
    
  class AnnouncementBar extends HTMLElement {
    connectedCallback() {
      if (sessionStorage.getItem('announcement-bar-dismissed') === 'true') {
        this.hidden = true;
        return;
      }

      const closeButton = this.querySelector('.announcement-bar__close');
      if (closeButton) {
        closeButton.addEventListener('click', () => {
          this.hidden = true;
          sessionStorage.setItem('announcement-bar-dismissed', 'true');
        });
      }

      const interval = Number(this.dataset.autorotate);
      if (interval > 0) {
        this.items = Array.from(this.querySelectorAll('.announcement-bar__item'));
        this.activeIndex = 0;

        if (this.items.length > 1 && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
          this.timer = setInterval(() => this.rotate(), interval);
        }
      }
    }

    rotate() {
      this.items[this.activeIndex].hidden = true;
      this.activeIndex = (this.activeIndex + 1) % this.items.length;
      this.items[this.activeIndex].hidden = false;
    }

    disconnectedCallback() {
      clearInterval(this.timer);
    }
  }

  customElements.define('announcement-bar', AnnouncementBar);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["countdown-banner"] && !Shopify.designMode) return;
  try {
    
  class CountdownTimer extends HTMLElement {
    connectedCallback() {
      this.endDate = new Date(this.dataset.endDate).getTime();
      this.daysEl = this.querySelector('[data-countdown-days]');
      this.hoursEl = this.querySelector('[data-countdown-hours]');
      this.minutesEl = this.querySelector('[data-countdown-minutes]');
      this.secondsEl = this.querySelector('[data-countdown-seconds]');

      if (Number.isNaN(this.endDate)) return;

      this.tick();
      this.interval = setInterval(() => this.tick(), 1000);
    }

    disconnectedCallback() {
      clearInterval(this.interval);
    }

    tick() {
      const remaining = this.endDate - Date.now();

      if (remaining <= 0) {
        clearInterval(this.interval);
        this.setValues(0, 0, 0, 0);
        return;
      }

      const days = Math.floor(remaining / (1000 * 60 * 60 * 24));
      const hours = Math.floor((remaining / (1000 * 60 * 60)) % 24);
      const minutes = Math.floor((remaining / (1000 * 60)) % 60);
      const seconds = Math.floor((remaining / 1000) % 60);

      this.setValues(days, hours, minutes, seconds);
    }

    setValues(days, hours, minutes, seconds) {
      if (this.daysEl) this.daysEl.textContent = String(days).padStart(2, '0');
      if (this.hoursEl) this.hoursEl.textContent = String(hours).padStart(2, '0');
      if (this.minutesEl) this.minutesEl.textContent = String(minutes).padStart(2, '0');
      if (this.secondsEl) this.secondsEl.textContent = String(seconds).padStart(2, '0');
    }
  }

  customElements.define('countdown-timer', CountdownTimer);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class GlobalDialogs extends HTMLElement {
    connectedCallback() {
      if (GlobalDialogs.initialized) return;
      GlobalDialogs.initialized = true;

      document.addEventListener('click', (event) => {
        const opener = event.target.closest('[data-open-dialog]');
        if (opener) {
          const dialog = document.getElementById(opener.dataset.openDialog);
          if (dialog && typeof dialog.showModal === 'function') {
            // Openers can be links (the cart icon points at /cart so it still
            // works without JS) — don't follow them once the dialog opens.
            event.preventDefault();
            dialog.showModal();
          }
          return;
        }

        const closer = event.target.closest('[data-close-dialog]');
        if (closer) {
          const dialog = closer.closest('dialog');
          if (dialog) dialog.close();
        }
      });

      document.addEventListener(
        'click',
        (event) => {
          if (event.target.tagName === 'DIALOG' && event.target.hasAttribute('open')) {
            const rect = event.target.getBoundingClientRect();
            const inside =
              rect.top <= event.clientY &&
              event.clientY <= rect.top + rect.height &&
              rect.left <= event.clientX &&
              event.clientX <= rect.left + rect.width;
            if (!inside) event.target.close();
          }
        },
        true
      );
    }
  }
  customElements.define('global-dialogs', GlobalDialogs);

  class DetailsDisclosure extends HTMLElement {
    connectedCallback() {
      this.details = this.querySelector('details');
      this.summary = this.querySelector('summary');
      this.summary.addEventListener('click', (event) => {
        event.preventDefault();
        const isOpen = this.details.hasAttribute('open');
        document
          .querySelectorAll('details-disclosure details[open]')
          .forEach((details) => details.removeAttribute('open'));
        if (!isOpen) this.details.setAttribute('open', '');
      });

      document.addEventListener('click', (event) => {
        if (!this.contains(event.target)) this.details.removeAttribute('open');
      });

      this.addEventListener('keydown', (event) => {
        if (event.key === 'Escape') this.details.removeAttribute('open');
      });
    }
  }
  customElements.define('details-disclosure', DetailsDisclosure);

  class StickyHeader extends HTMLElement {
    connectedCallback() {
      if (!this.hasAttribute('data-sticky')) return;
      const sentinel = this.querySelector('.header-sentinel');
      if (!sentinel || !('IntersectionObserver' in window)) return;

      const observer = new IntersectionObserver(
        ([entry]) => this.classList.toggle('is-stuck', !entry.isIntersecting),
        { threshold: 0 }
      );
      observer.observe(sentinel);
    }
  }
  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-carousel"] && !Shopify.designMode) return;
  try {
    
  class ProductCarousel extends HTMLElement {
    connectedCallback() {
      const section = this.closest('.product-carousel');
      if (!section) return;

      this.prevButton = section.querySelector('[data-carousel-prev]');
      this.nextButton = section.querySelector('[data-carousel-next]');

      this.prevButton?.addEventListener('click', () => this.scrollByAmount(-1));
      this.nextButton?.addEventListener('click', () => this.scrollByAmount(1));
    }

    scrollByAmount(direction) {
      const item = this.querySelector('.product-carousel__item');
      const amount = item ? item.getBoundingClientRect().width + 16 : this.clientWidth;
      this.scrollBy({ left: amount * direction, behavior: 'smooth' });
    }
  }

  customElements.define('product-carousel', ProductCarousel);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-details"] && !Shopify.designMode) return;
  try {
    
  class ProductDetails extends HTMLElement {
    connectedCallback() {
      this.tabs = Array.from(this.querySelectorAll('[data-details-tab]'));
      this.panels = Array.from(this.querySelectorAll('[data-details-panel]'));
      if (!this.tabs.length) return;

      this.tabs.forEach((tab) => {
        tab.addEventListener('click', () => this.select(tab));
      });

      this.querySelector('[role="tablist"]').addEventListener('keydown', (event) => this.onKeydown(event));
    }

    onKeydown(event) {
      const currentIndex = this.tabs.indexOf(document.activeElement);
      if (currentIndex === -1) return;

      let nextIndex = null;
      if (event.key === 'ArrowRight') nextIndex = (currentIndex + 1) % this.tabs.length;
      if (event.key === 'ArrowLeft') nextIndex = (currentIndex - 1 + this.tabs.length) % this.tabs.length;
      if (event.key === 'Home') nextIndex = 0;
      if (event.key === 'End') nextIndex = this.tabs.length - 1;
      if (nextIndex === null) return;

      event.preventDefault();
      this.select(this.tabs[nextIndex]);
      this.tabs[nextIndex].focus();
    }

    select(selectedTab) {
      this.tabs.forEach((tab, index) => {
        const isSelected = tab === selectedTab;
        tab.classList.toggle('product-details__tab--active', isSelected);
        tab.setAttribute('aria-selected', isSelected ? 'true' : 'false');
        tab.tabIndex = isSelected ? 0 : -1;

        const panel = this.panels[index];
        if (panel) panel.hidden = !isSelected;
      });
    }
  }

  customElements.define('product-details', ProductDetails);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"] && !Shopify.designMode) return;
  try {
    
  class ProductRecommendations extends HTMLElement {
    connectedCallback() {
      // The section stays hidden (and so has no box to observe) until it has
      // content, so it loads as soon as this deferred script runs rather than
      // waiting for an intersection.
      if (!this.dataset.url || this.dataset.loaded === 'true') return;
      this.load();
    }

    async load() {
      this.dataset.loaded = 'true';

      try {
        const response = await fetch(this.dataset.url);
        if (!response.ok) return;

        const parsed = new DOMParser().parseFromString(await response.text(), 'text/html');
        const recommendations = parsed.querySelector('product-recommendations');
        if (!recommendations || !recommendations.innerHTML.trim()) return;

        this.innerHTML = recommendations.innerHTML;
        this.hidden = false;
      } catch (error) {
        this.hidden = true;
      }
    }
  }

  customElements.define('product-recommendations', ProductRecommendations);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-tabs"] && !Shopify.designMode) return;
  try {
    
  class ProductTabs extends HTMLElement {
    connectedCallback() {
      this.tabButtons = Array.from(this.querySelectorAll('[data-tab-button]'));
      this.tabPanels = Array.from(this.querySelectorAll('[data-tab-panel]'));

      this.tabButtons.forEach((button) => {
        button.addEventListener('click', () => this.selectTab(button));
      });
    }

    selectTab(selectedButton) {
      this.tabButtons.forEach((button, index) => {
        const isSelected = button === selectedButton;
        button.classList.toggle('product-tabs__tab--active', isSelected);
        button.setAttribute('aria-selected', isSelected);

        const panel = this.tabPanels[index];
        if (!panel) return;
        panel.classList.toggle('product-tabs__panel--active', isSelected);
        panel.hidden = !isSelected;
      });
    }
  }

  customElements.define('product-tabs', ProductTabs);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["search"]) return;
  try {
    
  document.querySelector('[data-search-sort]')?.addEventListener('change', (event) => {
    event.target.form.requestSubmit();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["video"] && !Shopify.designMode) return;
  try {
    
  class VideoEmbed extends HTMLElement {
    connectedCallback() {
      this.querySelector('button')?.addEventListener('click', () => this.play());
    }

    play() {
      const host = this.dataset.host;
      const id = this.dataset.videoId;
      let src = '';

      if (host === 'youtube') {
        src = `https://www.youtube.com/embed/${id}?autoplay=1`;
      } else if (host === 'vimeo') {
        src = `https://player.vimeo.com/video/${id}?autoplay=1`;
      }

      if (!src) return;

      const iframe = document.createElement('iframe');
      iframe.src = src;
      iframe.className = 'video-section__iframe';
      iframe.allow = 'autoplay; fullscreen; picture-in-picture';
      iframe.allowFullscreen = true;
      this.replaceChildren(iframe);
    }
  }

  customElements.define('video-embed', VideoEmbed);

  } catch(e) { console.error(e); }
})();
})();
